export function fundMultiple(
  txMultiple: number,
  companyMultiple: number
): number {
  return companyMultiple / txMultiple;
}
